import Top_bar from '../../Components/topBar/topBar';
import './oeeView.css';

const OEEView = () => {
    return (
        <>
         <Top_bar />
            <div id="main" >
                <div id="iframe">
                    <iframe  
                        title="DENK - OEE e producao" 
                        src="https://app.powerbi.com/reportEmbed?reportId=c54a2d6b-626b-4ae6-88cb-ff7eef4e8e55&autoAuth=true&ctid=87cf8b7d-27e4-4b0b-a256-8a921ccf7b64" 
                        frameborder="0" 
                        allowFullScreen="true">
                            
                    </iframe>
                </div>
            </div>
        </>
    );
};

export default OEEView;